import { startOfDay } from 'date-fns';
import { convertZonedDateToSystemDate, convertSystemDateToZonedDate } from './DateUtils2.js';

const getTzStartOfDay = (tzDate) => {
    const systemDate = convertZonedDateToSystemDate(tzDate);
    const newDate = startOfDay(systemDate);
    return convertSystemDateToZonedDate(newDate);
};

export { getTzStartOfDay };
